export default __webpack_public_path__ + "static/media/QuienesSomos_Icon.e6991459.svg";